module.exports = __webpack_public_path__ + "static/img/katun07.9656d12.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blog/katun07.jpg
// module id = LKwN
// module chunks = 0